export default {
  view(page) {
    if (window.ga) {
      window.ga('send', 'pageview', { page });
      window.ga('clientTracker.send', 'pageview', { page });
    }
  },
};
